module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "video-thumbnail-base.c6ae75bb.png";